import React, { useState } from "react";
import "../../../../style/calendar.scss";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import "../style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import addDays from "date-fns/addDays";
import EAButton from "../../shared/Buttons/EAButton";
import { FaRegCalendarTimes } from "react-icons/fa";

interface IProps {
  exerciseName: string;
  getExercisesByDate: (date: Date, zone: string) => void;
  selectedDate: Date;
  handleCloseModal?: (boolean: boolean) => void;
  listaDat?: Date[];
  firstAvailableDate?: Date;
  soldOutDates?: Date[];
}
const CalendarDayPicker: React.FC<IProps> = ({
  getExercisesByDate,
  selectedDate,
  exerciseName,
  handleCloseModal,
  listaDat = [],
  soldOutDates = [],
  firstAvailableDate = new Date(),
}: IProps) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const [month, setMonth] = useState<Date>(new Date());
  const [hideNoAvailable, setHideNoAvailable] = useState<boolean>(false);

  const disabledDays = listaDat;



  const handleFirstAvailableClick = () => {
    setMonth(firstAvailableDate);
    getExercisesByDate(firstAvailableDate, exerciseName);
    setHideNoAvailable(true);
  };

  const handleDateSelect = (date: Date | undefined) => {
    const dateToUse = date || selectedDate;
    getExercisesByDate(dateToUse, exerciseName);
    if (handleCloseModal) handleCloseModal(false);
  };

  // Sprawdzamy czy miesiąc firstAvailableDate różni się od bieżącego
  const showNoAvailableInfo = firstAvailableDate.getMonth() !== new Date().getMonth() && !hideNoAvailable;

  return (
    <div className="calendar">
      {showNoAvailableInfo && (
        <div className="no-available-message">
          <h4>
            <FaRegCalendarTimes />
          </h4>

          <p>{t("Brak dostępnych terminów w tym miesiącu")}</p>
          <EAButton
            onClick={handleFirstAvailableClick}
            title={t("Wyszukaj najbliższy dostępny termin")}
            noMargins
            variant="text"
          />
        </div>
      )}

      <DayPicker
        mode="single"
        locale={locale}
        selected={selectedDate}
        fromDate={new Date()}
        month={month}
        onMonthChange={setMonth}
        onSelect={handleDateSelect}
        showOutsideDays
        modifiers={{
          soldOut: soldOutDates,
        }}
        modifiersClassNames={{
          selected: "my-selected",
          today: "my-today",
          soldOut: "my-sold-out",
        }}
        disabled={[...disabledDays, { from: new Date(addDays(new Date(), 240)), to: new Date(2300, 4, 29) }]}
      />

      <div className="calendar-legend flex-center-center">
        <div className="calendar-legend-item">
          <div className="calendar-legend-dot"></div>
          <b>{t("dostepne_terminy")}</b>
        </div>
        <div className="calendar-legend-item">
          <div className="calendar-legend-dot is-gray"></div>
          <b>{t("Wyprzedane dni")}</b>
        </div>
      </div>
    </div>
  );
};

export default CalendarDayPicker;
